import { v4 as uuidv4 } from "uuid";
import { getPDFBase64 } from "./generateW8BENXML";
import { formatDateForXML } from "../../../Utility/utility";
import { parseAddressComponents } from "../../../utils/formUtils";

export const generateW8IMYXML = async (inputData: any) => {
  // Initialize formData with all possible fields (similar to W-8IMYForm.tsx)
  const formData: any = {
    // Compulsory existing fields
    UniqueIdentifier: "",
    "Mailing address zip": "",
    "Mailing address state NonUS": "",
    "Mailing address city": "",
    "Mailing address country": "",
    "Mailing address street": "",
    "Permanent address city": "",
    "Permanent address country": "",
    "Permanent residence address": "",
    Print_name: "",
    "IMY-10_reference_number": "",
    Signature_date: "",
    "FTIN not legally required": "",
    Foreign_tax_identifying_number: "",
    FormName: "W-8IMY",
    Country_of_citizenship: "",
    Country_of_incorporation_organization: "",
    "Date of birth": "",
    Signature: "",
    Signing_capacity: "",
    "US_taxpayer identification number": "",

    // Certification checkboxes - only lowercase versions (real data)
    "IMY-14_Certification_Qualified_Intermediary": false,
    "IMY-15A_primary_withholding_responsibility": false,
    "IMY-15B_publicly_traded_partnerships": false,
    "IMY-15C_withholding_as_nominee": false,
    "IMY-15D_qualified_securities_lender": false,
    "IMY-15E_withholding_and_form_1099_reporting": false,
    "IMY-15F_form_1099_reporting_for_us": false,
    "IMY-15G_non_assumption_of_form_1099_reporting": false,
    "IMY-15H_chapter4_withholding_rate_pool": false,
    "IMY-15I_intermediary_orflow_through_entities": false,
    "IMY-16A_certification_qdd_meets_requirements": false,
    "IMY-16B_entity_classification_corporation": false,
    "IMY-16B_entity_classification_disregarded_entity": false,
    "IMY-16B_entity_classification_partnership": false,
    "IMY-17A_not_acting_as_qi": false,
    "IMY-17B_Transmit_withholding_certificates": "",
    "IMY-17C_Regulations_section_1.6049-4(c)(4)(iii)": "",
    "IMY-17D_Qualified_securities_lender": "",
    "IMY-17E_Alternative_withholding_statement": "",
    "IMY-18A_Financial_institution_in_territory": "",
    "IMY-18B_Withholding_agent_to_be_treated_as_US_person": "",
    "IMY-18C_Transmit_withholding_certificates": "",
    "IMY-18D_Publicly_traded_partnerships": "",
    "IMY-18E_US_person_and_nominee": "",
    "IMY-18F_Nominee_and_providing_withholding_statements": "",
    "IMY-19A_Reportable_amounts_not_effectively_connected": "",
    "IMY-19B_Foreign_bank_or_insurance_company": "",
    "IMY-19C_Transmit_certificates": "",
    "IMY-19D_US_person_for_sales_of_interests": "",
    "IMY-19E_Entity_is_US_branch": "",
    "IMY-19F_Not_acting_as_a_nominee": "",
    "IMY-20_Withholding_foreign_partnership": "",
    "IMY-21A_Foreign_partnership/trust": "",
    "IMY-21B_Lower-tier_partnership": "",
    "IMY-21C_Transfer_of_interest": "",
    "IMY-21D_Statement_for_modified_amount": "",
    "IMY-21E_Behalf_of_grantors": "",
    "IMY-21F_Alternative_withholding_statement": "",
    "IMY-22_Exempt_beneficial_owners": "",
    "IMY-23A_name_of_sponsoring_entity": "",
    "IMY-23B_QI/WP/WT": "",
    "IMY-23C_Controlled_foreign_corporation": "",
    "IMY-24A_Owner-documented_FFI_requirements": "",
    "IMY-24B_FFI_owner_reporting_statement": "",
    "IMY-24C_Auditor's_letter": "",
    "IMY-25_Non_registering_local_bank": "",
    "IMY-26_FFI_with_only_low_value_accounts": "",
    "IMY-27A_sponsored_investment_vehicle_name": "",
    "IMY-27B_FFI_solely": "",
    "IMY-28_Life_debt_investment": "",
    "IMY-29_Financial_institution_solely": "",
    "IMY-30A_Restricted_distributor": "",
    "IMY-30B_Prohibition_on_US_sales": "",
    "IMY-30C_Agreement_with_specific_prohibitions": "",
    "IMY-31_Regulations_section_1.1471-6(d)(4)": "",
    "IMY-32_IGA_country": "",
    "IMY-32_Model1_IGA": "",
    "IMY-32_Model2_IGA": "",
    "IMY-32_Non_reporting_financial_institution": "",
    "IMY-32_Treated_as": "",
    "IMY-32_Trustee_foreign": "",
    "IMY-32_Trustee_name": "",
    "IMY-32_Trustee_us": "",
    "IMY-33A_US_tax_treaty": "",
    "IMY-33B_Former_employees": "",
    "IMY-33C_50_Participants": "",
    "IMY-33D_Section_401(a)": "",
    "IMY-33E_Retirement_funds": "",
    "IMY-33F_Foreign_government_or_international_organization": "",
    "IMY-34_Nonfinancial_group_entity": "",
    "IMY-35_Start_up_company": "",
    "IMY-35_Textfield": "",
    "IMY-36_Liquidation_or_bankruptcy": "",
    "IMY-36_Textfield": "",
    "IMY-37A_Stock_traded": "",
    "IMY-37A_securities_market": "",
    "IMY-37B_Affiliated_group": "",
    "IMY-37B_affiliate_entity_name": "",
    "IMY-38_Bona_fide_residents": "",
    "IMY-39_Passive_income_and_assets": "",
    "IMY-40_Foreign_entity": "",
    "IMY-41_sponsor_name": "",
    "IMY-42_Line_41": "",
    "IMY-Disregarded_entity_GIIN": "",
    "IMY-Disregarded_entity_address_of_branch": "",
    "IMY-Disregarded_entity_city_state_of_branch": "",
    "IMY-Disregarded_entity_country_of_branch": "",
    "IMY-Disregarded_entity_name": "",
    "IMY-GIIN": "",
    "IMY-Name_of_organization": "",

    // Additional address fields for better mapping
    "Permanent city address": "",
    "Name of organization": "",

    // TASK 1: Use EXACT same fields as W8IMYFormModel
    // Chapter 3 Status (Part II) - exactly as in W8IMYFormModel
    "IMY-4_QI": false,
    "IMY-4_Non_qualified_intermediary": false,
    "IMY-4_Withholding_foreign_partnership": false,
    "IMY-4_Withholding_foreign_trust": false,
    "IMY-4_Non_withholding_foreign_partnership": false,
    "IMY-4_Non_withholding_foreign_simple_trust": false,
    "IMY-4_Non_withholding_foreign_grantor_trust": false,
    "IMY-4_Territory_financial_institution": false,
    "IMY-4_US_branch": false,

    // Chapter 4 Status (Part III) - exactly as in W8IMYFormModel
    "IMY-11_Branch_non_participating_FFI": false,
    "IMY-11_Participating_FFI": false,
    "IMY-11_Reporting_model1_FFI": false,
    "IMY-11_Reporting_model2_FFI": false,
    "IMY-11_US_Branch": false,
    "IMY-Non_participating_FFI": false,
    "IMY-Participating_FFI": false,
    "IMY-Reporting_model1_FFI": false,
    "IMY-Reporting_model2_FFI": false,
    "IMY-Territory_financial_institution": false,
    "IMY-Registered_deemed_compliant_FFI": false,
    "IMY-Sponsored_FFI": false,
    "IMY-Non_reporting_IGA_FFI": false,
    "IMY-Owner_documented_FFI": false,
    "IMY-Restricted_distributor": false,
    "IMY-Certified_deemed_local_bank": false,
    "IMY-Certified_deemed_low_value": false,
    "IMY-Certified_deemed_investment_vehicle": false,
    "IMY-Certified_deemed_debt_entity": false,
    "IMY-Certain_investment_entities": false,
    "IMY-Exempt_retirement_plans": false,
    "IMY-Excepted_non_financial_group": false,
    "IMY-Excepted_non_financial_startup": false,
    "IMY-Excepted_non_financial_liquidation": false,
    "IMY-Publicly_traded_NFFE": false,
    "IMY-Excepted_territory_NFFE": false,
    "IMY-Active_NFFE": false,
    "IMY-Passive_NFFE": false,
    "IMY-Direct_reporting_NFFE": false,
    "IMY-Sponsored_direct_reporting_NFFE": false,
    "IMY-Foreign_central_bank": false,

    // TIN checkbox fields - using exact response field names
    "IMY-8_us_tin_ein": false,
    "IMY-8_us_tin_qi_ein": false,
    "IMY-8_us_tin_wp_ein": false,
    "IMY-8_us_tin_wt_ein": false,
    "IMY-8_us_tin": "",

    // GIIN and other missing fields from user data
    "IMY-9A_giin": "",
    "IMY-13_disregarded_entity_giin": "",
    "IMY-32_model1_iga": false,
    "IMY-32_model2_iga": false,
    "IMY-32_treated_as": "",
    "IMY-37B_affiliate_securities_market": "",

    // Disregarded entity address fields (exact names from response)
    "IMY-12_disregarded_entity_address_of_branch": "",
    "IMY-12_disregarded_entity_city_state_of_branch": "",
    "IMY-12_disregarded_entity_country_of_branch": "",

    // Essential form control fields
    certify: false,
    isSigned: "",
    isModified: "",

    // Keep some legacy address fields for backward compatibility with form display
    "Permanent address line 2": "",
    "Permanent address line 3": "",
    "Permanent address state USCA": "",
    formType: "W-8IMY",

    "Permanent address is care of": "",
    "Permanent address is po box": "",
    "Permanent address is rural route": "",
    "Permanent address other": "",
    "Mailing address": "",
    "Mailing address line 2": "",
    "Mailing address line 3": "",
    "Mailing address state USCA": "",
    "Mailing address is care of": "",
    "Mailing address is po box": "",
    "Mailing address is rural route": "",
    "Mailing address other": "",
    "Disregarded entity line 2": "",
    "Taxpayer type": "",
    "Taxpayer TIN": "",
    GIINCheckBox: false,
    "GIIN Entered": "",
    "GIIN Applied For": false,
    "Foreign TIN": false,
    "Foreign taxpayer id": "",
    "Reference numbers": "",
    Other: "",
  };

  // Assign matching fields from inputData to formData with smart field name mapping
  if (inputData) {
    // First, direct mapping for exact matches
    Object.keys(formData).forEach((key) => {
      if (inputData.hasOwnProperty(key)) {
        formData[key] = inputData[key];
      }
    });

    // Second, assign ALL input data fields that don't conflict
    Object.keys(inputData).forEach((inputKey) => {
      if (!formData.hasOwnProperty(inputKey)) {
        formData[inputKey] = inputData[inputKey];
      }
    });
  }

  // Helper function to safely get values
  const getValue = (key: string, defaultValue: string = "") => formData[key] || defaultValue;

  // Helper function to safely get boolean values
  const getBooleanValue = (key: string) => (formData[key] ? "True" : "False");

  // Get entity type from Chapter 3 Status checkboxes
  const getEntityType = () => {
    // Then check individual checkbox fields
    if (formData["IMY-4_QI"]) {
      console.log("RETURNING: Qualified Intermediary");
      return "Qualified intermediary (including a QDD)";
    }
    if (formData["IMY-4_Non_qualified_intermediary"]) {
      console.log("RETURNING: Non Qualified Intermediary");
      return "Non Qualified Intermediary";
    }
    if (formData["IMY-4_Non_withholding_foreign_grantor_trust"]) {
      console.log("RETURNING: Non-withholding Foreign Grantor Trust");
      return "Non-withholding Foreign Grantor Trust";
    }
    if (formData["IMY-4_Non_withholding_foreign_partnership"]) {
      console.log("RETURNING: Non-withholding Foreign Partnership");
      return "Non-withholding Foreign Partnership";
    }
    if (formData["IMY-4_Non_withholding_foreign_simple_trust"]) {
      console.log("RETURNING: Non-withholding Foreign Simple Trust");
      return "Non-withholding Foreign Simple Trust";
    }
    if (formData["IMY-4_Territory_financial_institution"]) {
      console.log("RETURNING: Territory Financial Institution");
      return "Territory Financial Institution";
    }
    if (formData["IMY-4_US_branch"]) {
      console.log("RETURNING: U.S. Branch");
      return "U.S. Branch";
    }
    if (formData["IMY-4_Withholding_foreign_partnership"]) {
      console.log("RETURNING: Withholding Foreign Partnership");
      return "Withholding Foreign Partnership";
    }
    if (formData["IMY-4_Withholding_foreign_trust"]) {
      console.log("RETURNING: Withholding Foreign Trust");
      return "Withholding Foreign Trust";
    }

    console.log('Entity type not found, returning "Other"');
    return "Other";
  };
  const getDREFATCAEntitytype = () => {
    // Check for specific DRE entity types
    if (formData["IMY-11_Branch_non_participating_FFI"])
      return "Branch treated as nonparticipating FFI";
    if (formData["IMY-11_Participating_FFI"]) return "Participating FFI";
    if (formData["IMY-11_Reporting_model1_FFI"]) return "Reporting Model 1 FFI";
    if (formData["IMY-11_Reporting_model2_FFI"]) return "Reporting Model 2 FFI";
    if (formData["IMY-11_US_Branch"]) return "U.S. Branch";

    return "U.S. Branch";
  };

  // Get chapter 4 status from FATCA Status checkboxes - Using exact form field names with "5_" prefix
  const getChapter4Status = () => {
    // Nonparticipating FFI options
    if (formData["IMY-5_non_participating_FFI"]) return "Nonparticipating FFI";

    // Participating FFI options
    if (formData["IMY-5_participating_FFI"]) return "Participating FFI";
    if (formData["IMY-5_reporting_model1_FFI"]) return "Reporting Model 1 FFI";
    if (formData["IMY-5_reporting_model2_FFI"]) return "Reporting Model 2 FFI";

    // Deemed-compliant FFI options
    if (formData["IMY-5_registered_deemed_compliant_FFI"]) return "Registered deemed-compliant FFI";
    if (formData["IMY-5_sponsored_FFI"]) return "Sponsored FFI";
    if (formData["IMY-5_non_reporting_IGA_FFI"]) return "Nonreporting IGA FFI";
    if (formData["IMY-5_owner_documented_FFI"]) return "Owner-documented FFI";
    if (formData["IMY-5_restricted_distributor"]) return "Restricted distributor";
    if (formData["IMY-5_certified_deemed_local_bank"])
      return "Certified deemed-compliant nonregistering local bank";
    if (formData["IMY-5_certified_deemed_low_value"])
      return "Certified deemed-compliant FFI with only low-value accounts";
    if (formData["IMY-5_certified_deemed_investment_vehicle"])
      return "Certified deemed-compliant sponsored, closely held investment vehicle";
    if (formData["IMY-5_certified_deemed_debt_entity"])
      return "Certified deemed-compliant limited life debt investment entity";
    if (formData["IMY-5_certain_investment_entities"])
      return "Certain investment entities that do not maintain financial accounts";

    // Exempt beneficial owner options
    if (formData["IMY-5_exempt_retirement_plans"]) return "Exempt retirement plans";
    if (formData["IMY-5_foreign_central_bank"]) return "Foreign central bank of issue";

    // Excepted NFFE options
    if (formData["IMY-5_excepted_non_financial_group"]) return "Excepted nonfinancial group entity";
    if (formData["IMY-5_excepted_non_financial_startup"])
      return "Excepted nonfinancial start-up company";
    if (formData["IMY-5_excepted_non_financial_liquidation"])
      return "Excepted nonfinancial entity in liquidation or bankruptcy";
    if (formData["IMY-5_publicly_traded_NFFE"])
      return "Publicly traded NFFE or NFFE affiliate of a publicly traded corporation";
    if (formData["IMY-5_excepted_territory_NFFE"]) return "Excepted territory NFFE";

    // Active/Passive NFFE options
    if (formData["IMY-5_active_NFFE"]) return "Active NFFE";
    if (formData["IMY-5_passive_NFFE"]) return "Passive NFFE";
    if (formData["IMY-5_direct_reporting_NFFE"]) return "Direct reporting NFFE";
    if (formData["IMY-5_sponsored_direct_reporting_NFFE"]) return "Sponsored direct reporting NFFE";

    // Territory FI option
    if (formData["IMY-5_territory_financial_institution"]) return "Territory financial institution";

    return "Other";
  };

  // Generate related documents XML
  const generateRelatedDocumentsXml = async () => {
    let relatedDocumentsXml = "";

    // Helper function to get document type info
    const getDocumentTypeInfo = (documentType: string) => {
      const documentTypeMapping: Record<string, { typeId: string; type: string }> = {
        partnership_agreement: {
          typeId: "74B29767-B166-49A1-90C6-04D919FFF021",
          type: "Partnership Agreement",
        },
        trust_deed: {
          typeId: "E0E34437-CC13-487C-863E-248204E61086",
          type: "Trust Deed or Certified Extracts",
        },
        certificate_registration: {
          typeId: "F0B2D5EC-5C24-4FE5-A571-2610610FA3D1",
          type: "Certificate of Registration",
        },
        certificate_incorporation: {
          typeId: "F113A468-ADE7-4C20-82C4-33A496456F54",
          type: "Certificate of Incorporation",
        },
        armed_forces_card: {
          typeId: "5EBD9B1F-BEB2-4BB5-BCB9-35C105F278A5",
          type: "Armed Forces Card",
        },
        limitations_benefits: {
          typeId: "5309E91F-6B24-4183-9C7F-3A062658E625",
          type: "Limitations of Benefits Statement",
        },
        election_form: {
          typeId: "DB6649B1-F4BE-41D5-AAAD-4588B253C39D",
          type: "Election form - line 9 option",
        },
        public_register: {
          typeId: "58740ED7-F2EF-481D-B0FA-4703F257B1C6",
          type: "Public Register Extracts",
        },
        driving_license: {
          typeId: "9FECCC5A-4CC3-46C2-AB7D-53FB2E3DB0B8",
          type: "Driving License",
        },
        driverLicense: { typeId: "9FECCC5A-4CC3-46C2-AB7D-53FB2E3DB0B8", type: "Driving License" },
        state_eu: { typeId: "D525BDE1-E0A2-4F2A-B2CE-5AD75383264E", type: "State of the EU" },
        email: { typeId: "C2676B9E-BCFA-497E-8588-6B8B1DA00914", type: "eMail" },
        retroactive_statement: {
          typeId: "3DC45284-ACA4-494B-AA1F-6EBA8736F9E1",
          type: "Retroactive Statement",
        },
        birth_certificate: {
          typeId: "70612B92-D0F3-4347-9CC3-912B9597C800",
          type: "Birth Certificate",
        },
        passport: { typeId: "70825FED-AEBF-4EB8-949D-998D69D718F9", type: "Passport" },
        withholding_statement: {
          typeId: "872ACA95-E43E-4EFA-A494-9A4A97356365",
          type: "Withholding Statement",
        },
        email_alt: { typeId: "325FFDDE-2558-4E32-B7DA-A67435BF59F9", type: "eMail" },
        other: { typeId: "E697B03A-91D1-4CEB-8EC4-A7A4E53E5B30", type: "Other" },
        hybrid_status: {
          typeId: "5A447556-7724-484B-A6D4-BAE392B8FF22",
          type: "Hybrid Status - Supporting Documentation",
        },
        notional_principle: {
          typeId: "BB810C57-8652-4431-BEB2-BE50057C17DC",
          type: "Notional principle contracts statement",
        },
        connected_documentation: {
          typeId: "ACCDB44A-2518-4B06-95C2-BF837E64E343",
          type: "Connected documentation",
        },
        national_id_member: {
          typeId: "4EA07713-50FD-4427-AB0A-C3972E3A7BB0",
          type: "National ID Card of A Member",
        },
        form_w4: { typeId: "D9AFD794-205A-45C3-A64A-C5219F20CBB2", type: "Form W-4" },
        proof_residency: {
          typeId: "F1BC6DC5-19C6-441F-A133-CEDE22778968",
          type: "Proof of Residency Document",
        },
        affidavit: { typeId: "B6477F29-2FE4-4CC0-A58E-CF7B91F791E7", type: "Affidavit" },
        national_id: { typeId: "405AE4A8-A1FA-45EB-9449-D1C76EC101FB", type: "National ID Card" },
        effectively_connected: {
          typeId: "BD2028C8-56A5-4404-895A-D36F42535DDB",
          type: "Effectively connected income statement - line 9 option",
        },
        power_attorney: {
          typeId: "59AC92CD-62C8-46DC-BC33-DBAFA0716242",
          type: "Power of attorney statement",
        },
        us_counsel: {
          typeId: "B6A5ABBA-E61E-4C5C-9B43-E051D75A26F6",
          type: "U.S. counsel opinion statement",
        },
        work_visa: { typeId: "1F7944EA-CF76-40FB-B182-E3D1DE59A74A", type: "Work visa" },
        expatriate: {
          typeId: "7AE8E536-21FD-46A2-93B7-EE99477D7DE2",
          type: "Expatriate Documentation",
        },
      };

      // Normalize the document type by removing common prefixes and converting to lowercase
      const normalizedType = documentType
        .toLowerCase()
        .replace(/^idDocument\./, "")
        .replace(/\.pdf$/, "");

      // Try direct match first
      if (documentTypeMapping[normalizedType]) {
        return documentTypeMapping[normalizedType];
      }

      // Try partial matches for common document types
      if (normalizedType.includes("passport")) {
        return documentTypeMapping["passport"];
      }
      if (normalizedType.includes("driver") || normalizedType.includes("license")) {
        return documentTypeMapping["driving_license"];
      }
      if (normalizedType.includes("national") && normalizedType.includes("id")) {
        return documentTypeMapping["national_id"];
      }

      // Default to 'Other' if no match found
      return documentTypeMapping["other"];
    };

    // Handle single document case from original code
    if (formData.idDocumentUrl) {
      const docContent = await getPDFBase64(formData.idDocumentUrl);
      const docTypeInfo = getDocumentTypeInfo(formData.idDocumentType || "other");

      relatedDocumentsXml += `
      <RelatedDocument>
        <ID>${uuidv4()}</ID>
        <Type>${docTypeInfo.type}</Type>
        <TypeID>${docTypeInfo.typeId}</TypeID>
        <File>
          <Name>${formData.idDocumentType || "id_document"}.pdf</Name>
          <Data>${docContent}</Data>
        </File>
      </RelatedDocument>`;
    }

    // Handle multiple documents if provided in docs array
    if (formData.docs && Array.isArray(formData.docs)) {
      for (const doc of formData.docs) {
        if (doc.url) {
          // Make sure to await the PDF base64 conversion
          const docContent = await getPDFBase64(doc.url);
          const docTypeInfo = getDocumentTypeInfo(doc.type || "other");

          relatedDocumentsXml += `
          <RelatedDocument>
            <Type>${docTypeInfo.type}</Type>
            <TypeID>${docTypeInfo.typeId}</TypeID>
            <File>
              <Name>${doc.name || "document.pdf"}</Name>
              <Data>${docContent}</Data>
            </File>
          </RelatedDocument>`;
        }
      }
    }

    return relatedDocumentsXml;
  };
  const relatedDocumentsXml = await generateRelatedDocumentsXml();

  // Generate original file XML if viewPdf is provided
  const generateOriginalFileXml = async () => {
    const viewPdfUrl = getValue("viewPdf", "");
    if (viewPdfUrl) {
      try {
        const originalFileContent = await getPDFBase64(viewPdfUrl, formData.fileImportId);
        const fileName = viewPdfUrl.split("/").pop() || "original_document.pdf";

        return `
        <OriginalFile>
          <Name>${fileName}</Name>
          <Data>${originalFileContent}</Data>
        </OriginalFile>`;
      } catch (error) {
        console.error("Error converting original PDF to base64:", error);
        return "<OriginalFile></OriginalFile>";
      }
    }
    return "<OriginalFile></OriginalFile>";
  };

  const originalFileXml = await generateOriginalFileXml();

  // Parse mailing address components if Mailing address city is not empty
  let mailingAddressParsed = { city: "", state: "", postalCode: "" };
  const mailingCityAddress = getValue("Mailing address city", "");
  if (mailingCityAddress && mailingCityAddress.trim() !== "") {
    mailingAddressParsed = parseAddressComponents(mailingCityAddress);
  }

  // Parse permanent city address if available and not already parsed
  let permanentCityAddressField: { city?: string; state?: string; postalCode?: string } = {};
  const permanentCityAddress = getValue("Permanent city address", "");
  if (permanentCityAddress && permanentCityAddress.trim() !== "") {
    permanentCityAddressField = parseAddressComponents(permanentCityAddress);
  }
  const xml = `
  <W_8IMY_OCT_2021>
        <UniqueIdentifier>${getValue("UniqueIdentifier")}</UniqueIdentifier>
        <UIDreferenceline>False</UIDreferenceline>
        <Instructor_Identifier>${getValue("UniqueIdentifier")}</Instructor_Identifier>
        <ElectronicRecipientStatement>True</ElectronicRecipientStatement>
        <ElectronicRecipientStatementDate>${new Date().toISOString()}</ElectronicRecipientStatementDate>
        <Entity>${getValue("Name of organization") || getValue("IMY-Name_of_organization")}</Entity>
        <CommonInfo>
            <EntityTypes>
                <EntityType>${getEntityType()}</EntityType>
            </EntityTypes>
            <EntityClassification />
            <InitialEntityTypeSelection>Intermediary</InitialEntityTypeSelection>
            <FATCAEntityType>${getChapter4Status()}</FATCAEntityType>
            <Individual>
                <FirstName />
                <LastName />
                <CountryOfBirth />
                <CountryOfBirthOther />
                <CountryOfCitizenshipForTax />
                <CountryOfCitizenshipForTaxOther />
                <CityTownOfBirth />
                <PlaceofBirth />
                <AdditionalTaxJurisdictions />
            </Individual>
            <Business>
                <Name>${getValue("Name of organization") || getValue("IMY-Name_of_organization")}</Name>
                <Country>${getValue("Country_of_incorporation_organization")}</Country>
                <CountryOther />
                <DoingBusinessAsName>${getValue("IMY-Disregarded_entity_name")}</DoingBusinessAsName>
                <DREAddress>
                    <Line1>${getValue("IMY-12_disregarded_entity_address_of_branch") || getValue("IMY-branchAddress") || getValue("IMY-disregarded_entity_address_of_branch")}</Line1>
                    <Line2 />
                    <Line3 />
                    <City_Town>${getValue("IMY-12_disregarded_entity_city_state_of_branch") || getValue("IMY-branchCity_State_city") || getValue("IMY-disregarded_entity_city_state_of_branch")}</City_Town>
                    <State_Province>${getValue("IMY-branchCity_State_state")}</State_Province>
                    <Country>${getValue("IMY-12_disregarded_entity_country_of_branch") || getValue("IMY-branchCountry") || getValue("IMY-disregarded_entity_country_of_branch")}</Country>
                    <CountryOther />
                    <Zip_PostalCode>${getValue("IMY-branchCity_State_postal")}</Zip_PostalCode>
                    <IsCare_of_address>False</IsCare_of_address>
                    <IsP_O_Box>False</IsP_O_Box>
                    <IsRuralRoute>False</IsRuralRoute>
                </DREAddress>
                		<DREGIIN>${getValue("IMY-13_disregarded_entity_giin") || getValue("GIIN") || getValue("IMY-GIIN") || getValue("IMY-9A_giin")}</DREGIIN>
                <DREFATCAEntitytype>${getDREFATCAEntitytype()}</DREFATCAEntitytype>
                <JurisdictionTaxCountry />
                		<SponsoringEntityName>${getValue("IMY-23A_name_of_sponsoring_entity") || getValue("IMY-27A_sponsored_investment_vehicle_name") || getValue("IMY-41_sponsor_name")}</SponsoringEntityName>
                <SponsoringEntityGIIN />
                <TrusteeName />
                <TrusteeGIIN />
                <AdditionalTaxJurisdictions />
                <IsSpecifiedUSPerson>${getBooleanValue("IsSpecifiedUSPerson")}</IsSpecifiedUSPerson>
                <SpecifiedPersonUS>NA</SpecifiedPersonUS>
                <IsSpecifiedUKPerson>${getBooleanValue("IsSpecifiedUKPerson")}</IsSpecifiedUKPerson>
                <SpecifiedPersonUK>NA</SpecifiedPersonUK>
                <IsSpecifiedCRSPerson>${getBooleanValue("IsSpecifiedCRSPerson")}</IsSpecifiedCRSPerson>
                <SpecifiedPersonCRS>NA</SpecifiedPersonCRS>
            </Business>
            <PermanentAddress>
                <Line1>${getValue("Permanent residence address")}</Line1>
                <Line2>${getValue("Permanent address line 2")}</Line2>
                <Line3>${getValue("Permanent address line 3")}</Line3>
                <City_Town>${getValue("Permanent address city") || permanentCityAddressField.city}</City_Town>
                <State_Province>${getValue("Permanent address state NonUS") || getValue("Permanent address state USCA") || permanentCityAddressField.state}</State_Province>
                <Country>${getValue("Permanent address country")}</Country>
                <CountryOther />
                <Zip_PostalCode>${getValue("Permanent address zip") || permanentCityAddressField.postalCode}</Zip_PostalCode>
                <IsCare_of_address>${getValue("Permanent address is care of") === "yes" ? "True" : "False"}</IsCare_of_address>
                <IsP_O_Box>${getValue("Permanent address is po box") === "yes" ? "True" : "False"}</IsP_O_Box>
                <IsRuralRoute>${getValue("Permanent address is rural route") === "yes" ? "True" : "False"}</IsRuralRoute>
            </PermanentAddress>
            <MailingAddress>
                <Line1>${getValue("Mailing address")}</Line1>
                <Line2>${getValue("Mailing address line 2")}</Line2>
                <Line3>${getValue("Mailing address line 3")}</Line3>
                <City_Town>${getValue("Mailing city address") || mailingAddressParsed.city}</City_Town>
                <State_Province>${getValue("Mailing address state NonUS") || getValue("Mailing address state USCA") || mailingAddressParsed.state}</State_Province>
                <Country>${getValue("Mailing address country")}</Country>
                <CountryOther />
                <Zip_PostalCode>${getValue("Mailing address zip") || mailingAddressParsed.postalCode}</Zip_PostalCode>
                <IsCare_of_address>${getValue("Mailing address is care of") === "yes" ? "True" : "False"}</IsCare_of_address>
                <IsP_O_Box>${getValue("Mailing address is po box") === "yes" ? "True" : "False"}</IsP_O_Box>
                <IsRuralRoute>${getValue("Mailing address is rural route") === "yes" ? "True" : "False"}</IsRuralRoute>
            </MailingAddress>
            <ContactInfo>
                <FirstName>${getValue("Print_name").split(" ")[0] || ""}</FirstName>
                <LastName>${getValue("Print_name").split(" ").slice(1).join(" ") || ""}</LastName>
                <Email />
                <SignatoryEmail />
                <TelephoneCountry />
                <TelephoneNumber />
                <CellNumber />
            </ContactInfo>
            <SubsidiaryInfo>
                <SubsidiaryId />
                <SubsidiaryName />
                <SubsidiaryContactName />
                <SubsidiaryContactTelephone />
                <SubsidiaryContactEmail />
            </SubsidiaryInfo>
            <CitizenshipInfo>
                <IsUSPerson />
                <IsUSGreenCardHolder />
                <IsDualCitizenshipHolder />
                <DoesDualCitizenshipIncludeAmerica />
                <IsBornOrganisedInUS />
                <HasRenouncedCitizenship />
                <DateRenouncedCitizenship />
                <AreCountryForTaxAndBirthDifferent />
                <InUSA31DaysCurrentYear />
            </CitizenshipInfo>
            <IsOnBehalfOfSomeoneElse>False</IsOnBehalfOfSomeoneElse>
            <Proxy>
                <FirstName />
                <LastName />
                <Capacity />
                <CapacityOther />
                <PrimaryContactNumber />
            </Proxy>
            <NoUSSiDeclarationConfirmed />
            <NoUSSiDeclarationPart2_3Skipped>False</NoUSSiDeclarationPart2_3Skipped>
            <IgnoredRules>
                <IgnoredRule>
                    <Rule>TIN128</Rule>
                    <Comment />
                </IgnoredRule>
            </IgnoredRules>
            <NonUSIndividual_IsClaimingECI />
            <NonUSIndividual_IsForIndependentPersonalServices />
            <NonUSIndividual_IsPublicEntertainer />
            <NonUSIndividual_IsResidentNoSpecificProvision />
            <NonUSIndividual_IsForDependentPersonalServices />
            <NonUSIndividual_IsForScholarshipFellowshipAndPersonalServicesIncome />
            <NonUSIndividual_PartOfWhichNotClaimingTaxTreatyWithholdingExemption />
            <NonUSIndividual_IsNotClaimingTaxTreatyWithholdingExemption />
            <NonUSIndividual_IsForScholarshipFellowshipNoPersonalServicesIncome />
            <NonUSIndividual_IsForOnlyForeignStatusOrTreatyBenefits />
            <SubmissionGroupId />
            <SelectedOptionsonGuide4 />
        </CommonInfo>
        <TaxpayerIdentification>
            <Type>${getValue("Taxpayer type") || "EIN"}</Type>
            <GIINAppliedFor>${getBooleanValue("GIIN Applied For")}</GIINAppliedFor>
            <GIINNotApplicable>False</GIINNotApplicable>
            <GIIN>${getValue("IMY-9A_giin") || getValue("GIIN") || getValue("IMY-GIIN")}</GIIN>
            <EIN>${getValue("U.S. taxpayer identification number") || getValue("US_taxpayer identification number") || getValue("IMY-8_us_tin")}</EIN>
            <ForeignTaxpayerId>${getValue("IMY-9B_foreign_tax_identifying_number") || getValue("Foreign_tax_identifying_number")}</ForeignTaxpayerId>
            <TINFormatNotAvail>${getBooleanValue("Foreign TIN")}</TINFormatNotAvail>
            <ForeignTaxpayerCountry>${getValue("Country_of_incorporation_organization")}</ForeignTaxpayerCountry>
            <ForeignTinUnavailable>False</ForeignTinUnavailable>
            <ForeignTinUnavailableReason />
            <IsAppliedForTIN>False</IsAppliedForTIN>
            <UnexpectedTINTypeExplanation />
            <UnexpectedTINTypeExplanationConfirmed />
            <UnexpectedTINTypeContentBlock />
            <CheckifFTINnotlegallyrequired>${getBooleanValue("Foreign TIN")}</CheckifFTINnotlegallyrequired>
            <IsFurtherExplanation>False</IsFurtherExplanation>
            <WrittenStatementReasons />
            <WrittenStatementReasonsAdditionalInformation />
            <TINCheck>
                <IsCheckPreformed>False</IsCheckPreformed>
                <IsSuccessful>False</IsSuccessful>
                <Date>${new Date().toISOString()}</Date>
            </TINCheck>
        </TaxpayerIdentification>
        <SignInfo>
            <IsSigned>${getBooleanValue("isMapDone") === "False" ? (getValue("Signature", "").trim() !== "" ? true : false) : getValue("isSigned") === "yes" ? true : false}</IsSigned>
            <By>${getValue("Print_name") || getValue("Signer_printed_name")}</By>
            <Capacity>${getValue("Signing_capacity")}</Capacity>
             <SignatureUnreadable>${getBooleanValue("Signature_unreadable")}</SignatureUnreadable>
            <Date>${formatDateForXML(getValue("Signature_date") || getValue("Signature_date"))}</Date>
            <UserLocalTime>${new Date().toLocaleString()}</UserLocalTime>
            <UserLocalTimeZone>Coordinated Universal Time</UserLocalTimeZone>
            <EnteredConfirmationCode />
        </SignInfo>
        <Tag>
            <SubmissionDate>${new Date().toISOString()}</SubmissionDate>
            <IsFromComplyExchangeService>True</IsFromComplyExchangeService>
            <IsFromBureau>False</IsFromBureau>
            <IsPaperForm>False</IsPaperForm>
            <IsE_form>True</IsE_form>
            <RetroactiveStatement>
                <IsSigned>${getValue("isSigned") === "yes" ? "True" : "False"}</IsSigned>
                <SignedBy>${getValue("Print_name") || getValue("Signer_printed_name")}</SignedBy>
                <SignDate>${formatDateForXML(getValue("Signature_date"))}</SignDate>
                <EffectiveDate>${new Date().toISOString()}</EffectiveDate>
                <ChangeinCircumstanceDate>${new Date().toISOString()}</ChangeinCircumstanceDate>
                <ReasonForChange />
                <Explanation />
                <RetroSignBy />
                <StatementText>I declare, under penalties of perjury, that I have examined the Form W-8IMY submission that I am providing and that the information and certifications contained therein remain the same and unchanged throughout the period beginning on ${new Date().toISOString()} to the date of the submission here and that they were true, correct and complete during the entire period.If any information or certifications were not true, correct and complete for that entire period enter the date from when they were, providing additional written information below supporting the changes in circumstances back to the account opening date provided above.</StatementText>
            </RetroactiveStatement>
        </Tag>
        <RelatedDocuments>
          ${relatedDocumentsXml}
        </RelatedDocuments>
        ${originalFileXml}
        <AgentLogo />
        <FATCAEntityType>${getChapter4Status()}</FATCAEntityType>
        <ReferenceNumbers>${getValue("IMY-10_reference_number")}</ReferenceNumbers>
        <Line11BranchNonParticipatingFFI>${getBooleanValue("IMY-11_Branch_non_participating_FFI")}</Line11BranchNonParticipatingFFI>
        <Line11ParticipatingFFI>${getBooleanValue("IMY-11_Participating_FFI")}</Line11ParticipatingFFI>
        <Line11ReportingModel1FFI>${getBooleanValue("IMY-11_Reporting_model1_FFI")}</Line11ReportingModel1FFI>
        <Line11ReportingModel2FFI>${getBooleanValue("IMY-11_Reporting_model2_FFI")}</Line11ReportingModel2FFI>
        <Line11USBranch>${getBooleanValue("IMY-11_US_Branch")}</Line11USBranch>
        <Line14>${getBooleanValue("IMY-14_Certification_Qualified_Intermediary")}</Line14>
        <Line15a>${getBooleanValue("IMY-15A_primary_withholding_responsibility") || getBooleanValue("IMY-15A_Primary_withholding_responsibility")}</Line15a>
        <Line15b>${getBooleanValue("IMY-15B_publicly_traded_partnerships") || getBooleanValue("IMY-15B_Publicly_traded_partnerships")}</Line15b>
        <Line15c>${getBooleanValue("IMY-15C_withholding_as_nominee") || getBooleanValue("IMY-15C_Withholding_as_nominee")}</Line15c>
        <Line15d>${getBooleanValue("IMY-15D_qualified_securities_lender") || getBooleanValue("IMY-15D_Qualified_securities_lender")}</Line15d>
        <Line15e>${getBooleanValue("IMY-15E_withholding_and_form_1099_reporting") || getBooleanValue("IMY-15E_Withholding_and_Form_1099_reporting")}</Line15e>
        <Line15f>${getBooleanValue("IMY-15F_form_1099_reporting_for_us") || getBooleanValue("IMY-15F_Form_1099_reporting_for_US")}</Line15f>
        <Line15g>${getBooleanValue("IMY-15G_non_assumption_of_form_1099_reporting") || getBooleanValue("IMY-15G_Non-assumption+_of_Form_1099_reporting")}</Line15g>
        <Line15h>${getBooleanValue("IMY-15H_chapter4_withholding_rate_pool") || getBooleanValue("IMY-15H-Chapter4_withholding_rate_pool")}</Line15h>
        <Line15i>${getBooleanValue("IMY-15I_intermediary_orflow_through_entities") || getBooleanValue("IMY-15I_Intermediary_orflow-through_entities")}</Line15i>
        <Line16a>${getBooleanValue("IMY-16A_certification_qdd_meets_requirements") || getBooleanValue("IMY-16A_Certification_QDD_meets_requirements")}</Line16a>
        <Line16Corporation>${getBooleanValue("IMY-16B_entity_classification_corporation") || getBooleanValue("IMY-16B_Entity_classification_corporation")}</Line16Corporation>
        <Line16Partnership>${getBooleanValue("IMY-16B_entity_classification_partnership") || getBooleanValue("IMY-16B_Entity_classification_partnership")}</Line16Partnership>
        <Line16DisregardedEntity>${getBooleanValue("IMY-16B_entity_classification_disregarded_entity") || getBooleanValue("IMY-16B_Entity_classification_disregarded_entity")}</Line16DisregardedEntity>
        <Line17a>${getBooleanValue("IMY-17A_not_acting_as_qi") || getBooleanValue("IMY-17A_not_acting_as_QI")}</Line17a>
        <Line17b>${getBooleanValue("IMY-17B_transmit_withholding_certificates") || getBooleanValue("IMY-17B_Transmit_withholding_certificates")}</Line17b>
        <Line17c>${getBooleanValue("IMY-17C_nqi_withholding_rate_pool") || getBooleanValue("IMY-17C_Regulations_section_1.6049-4(c)(4)(iii)")}</Line17c>
        <Line17d>${getBooleanValue("IMY-17D_qualified_securities_lender") || getBooleanValue("IMY-17D_Qualified_securities_lender")}</Line17d>
        <Line17e>${getBooleanValue("IMY-17E_alternative_withholding_statement") || getBooleanValue("IMY-17E_Alternative_withholding_statement")}</Line17e>
        <Line18a>${getBooleanValue("IMY-18A_tfi_certification") || getBooleanValue("IMY-18A_Financial_institution_in_territory")}</Line18a>
        <Line18b>${getBooleanValue("IMY-18B_tfi_us_person_treatment") || getBooleanValue("IMY-18B_Withholding_agent_to_be_treated_as_US_person")}</Line18b>
        <Line18c>${getBooleanValue("IMY-18C_transmit_withholding_certificates") || getBooleanValue("IMY-18C_Transmit_withholding_certificates")}</Line18c>
        <Line18d>${getBooleanValue("IMY-18D_publicly_traded_partnerships") || getBooleanValue("IMY-18D_Publicly_traded_partnerships")}</Line18d>
        <Line18e>${getBooleanValue("IMY-18E_us_person_and_nominee") || getBooleanValue("IMY-18E_US_person_and_nominee")}</Line18e>
        <Line18f>${getBooleanValue("IMY-18F_tfi_not_nominee") || getBooleanValue("IMY-18F_Nominee_and_providing_withholding_statements")}</Line18f>
        <Line19a>${getBooleanValue("IMY-19A_us_branch_certification") || getBooleanValue("IMY-19A_Reportable_amounts_not_effectively_connected")}</Line19a>
        <Line19b>${getBooleanValue("IMY-19B_us_branch_agreement") || getBooleanValue("IMY-19B_Foreign_bank_or_insurance_company")}</Line19b>
        <Line19c>${getBooleanValue("IMY-19C_transmit_certificates") || getBooleanValue("IMY-19C_Transmit_certificates")}</Line19c>
        <Line19d>${getBooleanValue("IMY-19D_us_branch_ptp") || getBooleanValue("IMY-19D_US_person_for_sales_of_interests")}</Line19d>
        <Line19e>${getBooleanValue("IMY-19E_us_branch_nominee") || getBooleanValue("IMY-19E_Entity_is_US_branch")}</Line19e>
        <Line19f>${getBooleanValue("IMY-19F_us_branch_not_nominee") || getBooleanValue("IMY-19F_Not_acting_as_a_nominee")}</Line19f>
        <Line20>${getBooleanValue("IMY-20_withholding_foreign_partnership") || getBooleanValue("IMY-20_Withholding_foreign_partnership")}</Line20>
        <Line21a>${getBooleanValue("IMY-21A_foreign_partnership_trust") || getBooleanValue("IMY-21A_Foreign_partnership/trust")}</Line21a>
        <Line21b>${getBooleanValue("IMY-21B_lower_tier_partnership") || getBooleanValue("IMY-21B_Lower-tier_partnership")}</Line21b>
        <Line21c>${getBooleanValue("IMY-21C_transfer_of_interest") || getBooleanValue("IMY-21C_Transfer_of_interest")}</Line21c>
        <Line21d>${getBooleanValue("IMY-21D_statement_for_modified_amount") || getBooleanValue("IMY-21D_Statement_for_modified_amount")}</Line21d>
        <Line21e>${getBooleanValue("IMY-21E_behalf_of_grantors") || getBooleanValue("IMY-21E_Behalf_of_grantors")}</Line21e>
        <Line21f>${getBooleanValue("IMY-21F_alternative_withholding_statement") || getBooleanValue("IMY-21F_Alternative_withholding_statement")}</Line21f>
        <Line22>${getBooleanValue("IMY-22_exempt_beneficial_owners") || getBooleanValue("IMY-22_Exempt_beneficial_owners")}</Line22>
        <Line23aSponsoringEntityName>${getValue("IMY-23A_name_of_sponsoring_entity")}</Line23aSponsoringEntityName>
        <Line23b>${getBooleanValue("IMY-23B_sponsored_ffi_investment") || getBooleanValue("IMY-23B_QI/WP/WT")}</Line23b>
        <Line23c>${getBooleanValue("IMY-23C_controlled_foreign_corporation") || getBooleanValue("IMY-23C_Controlled_foreign_corporation")}</Line23c>
        <Line24a>${getBooleanValue("IMY-24A_owner_documented_ffi") || getBooleanValue("IMY-24A_Owner-documented_FFI_requirements")}</Line24a>
        <Line24b>${getBooleanValue("IMY-24B_FFI_owner_reporting_statement")}</Line24b>
        <Line24c>${getBooleanValue("IMY-24C_owner_documented_ffi_auditor") || getBooleanValue("IMY-24C_Auditor's_letter")}</Line24c>
        <Line25>${getBooleanValue("IMY-25_nonregistering local bank _certification") || getBooleanValue("IMY-25_Non_registering_local_bank")}</Line25>
        <Line26>${getBooleanValue("IMY-26_low_value_accounts") || getBooleanValue("IMY-26_FFI_with_only_low_value_accounts")}</Line26>
        <Line27aSponsoringEntityName>${getValue("IMY-27A_sponsored_investment_vehicle_name")}</Line27aSponsoringEntityName>
        <Line27b>${getBooleanValue("IMY-27B_sponsored_investment_vehicle") || getBooleanValue("IMY-27B_FFI_solely")}</Line27b>
        <Line28>${getBooleanValue("IMY-28_limited_life_debt") || getBooleanValue("IMY-28_Life_debt_investment")}</Line28>
        <Line29>${getBooleanValue("IMY-29_financial_institution_solely") || getBooleanValue("IMY-29_Financial_institution_solely")}</Line29>
        <Line30a>${getBooleanValue("IMY-30A_restricted_distributor") || getBooleanValue("IMY-30A_Restricted_distributor")}</Line30a>
        <Line30b>${getBooleanValue("IMY-30B_restricted_distributor_agreement") || getBooleanValue("IMY-30B_Prohibition_on_US_sales")}</Line30b>
        <Line30c>${getBooleanValue("IMY-30C_restricted_distributor_current") || getBooleanValue("IMY-30C_Agreement_with_specific_prohibitions")}</Line30c>
        <Line31>${getBooleanValue("IMY-31_central_bank") || getBooleanValue("IMY-31_Regulations_section_1.1471-6(d)(4)")}</Line31>
        <Line32>${getBooleanValue("IMY-32_nonreporting_iga_ffi")}</Line32>

        <Line32IGACountry>${getValue("IMY-32_iga_country")}</Line32IGACountry>
        <Line32IGACountryOther>${getValue("IMY-32-othe")}</Line32IGACountryOther>
        <Line32Model1IGA>${getBooleanValue("IMY-32_model1_iga")}</Line32Model1IGA>
        <Line32Model2IGA>${getBooleanValue("IMY-32_model2_iga")}</Line32Model2IGA>
        <Line32IGATreatedAs>${getValue("IMY-32_treated_as") || getValue("IMY-32_Treated_as")}</Line32IGATreatedAs>
        <Line32SponsoringEntityName>${getValue("IMY-32_trustee_name")}</Line32SponsoringEntityName>
        <Line32TrusteeUS>${getBooleanValue("IMY-32_trustee_us")}</Line32TrusteeUS>
        <Line32TrusteeForeign>${getBooleanValue("IMY-32_trustee_foreign")}</Line32TrusteeForeign>
        <Line33a>${getBooleanValue("IMY-33A_retirement_plan_treaty") || getBooleanValue("IMY-33A_US_tax_treaty")}</Line33a>
        <Line33b>${getBooleanValue("IMY-33B_retirement_plan_employer") || getBooleanValue("IMY-33B_Former_employees")}</Line33b>
        <Line33c>${getBooleanValue("IMY-33C_retirement_plan_small") || getBooleanValue("IMY-33C_50_Participants")}</Line33c>
        <Line33d>${getBooleanValue("IMY-33D_retirement_plan_401a")}</Line33d>
        <Line33e>${getBooleanValue("IMY-33E_retirement_plan_investment") || getBooleanValue("IMY-33E_Retirement_funds")}</Line33e>
        <Line33f>${getBooleanValue("IMY-33F_retirement_plan_government") || getBooleanValue("IMY-33F_Foreign_government_or_international_organization")}</Line33f>
        <Line34>${getBooleanValue("IMY-34_nonfinancial_group_entity") || getBooleanValue("IMY-34_Nonfinancial_group_entity")}</Line34>
        <Line35>${getBooleanValue("IMY-35_startup_company_certification") || getBooleanValue("IMY-35_Start_up_company")}</Line35>
        <Line35Date>${getValue("IMY-35_startup_formation_date") || getValue("IMY-35_Textfield")}</Line35Date>
        <Line36>${getBooleanValue("IMY-36_Liquidation_or_bankruptcy")}</Line36>
        <Line36Date>${getValue("IMY-36_liquidation_filing_date") || getValue("IMY-36_Textfield")}</Line36Date>
        <Line37a>${getBooleanValue("IMY-37A_publicly_traded_nffe") || getBooleanValue("IMY-37A_Stock_traded")}</Line37a>
        <Line37aSecuritiesMarketName>${getValue("IMY-37A_securities_market")}</Line37aSecuritiesMarketName>
        <Line37b>${getBooleanValue("IMY-37B_nffe_affiliate") || getBooleanValue("IMY-37B_Affiliated_group")}</Line37b>
        <Line37bEntityName>${getValue("IMY-37B_affiliate_entity_name")}</Line37bEntityName>
        <Line37bSecuritiesMarketName>${getValue("IMY-37B_affiliate_securities_market")}</Line37bSecuritiesMarketName>
        <Line38>${getBooleanValue("IMY-38_territory_nffe") || getBooleanValue("IMY-38_Bona_fide_residents")}</Line38>
        <Line39>${getBooleanValue("IMY-39_active_nffe") || getBooleanValue("IMY-39_Passive_income_and_assets")}</Line39>
        <Line40>${getBooleanValue("IMY-40_passive_nffe") || getBooleanValue("IMY-40_Foreign_entity")}</Line40>
        <Line41SponsoringEntityName>${getValue("IMY-41_sponsor_name")}</Line41SponsoringEntityName>
        <Line42>${getBooleanValue("IMY-42_sponsored_direct_reporting") || getBooleanValue("IMY-42_Line_41")}</Line42>
        <IsAllocationStatementRequired>False</IsAllocationStatementRequired>
        <AllocationStatementOption />
        <SubstituteFormStatement>The Internal Revenue Service does not require your consent to any provisions of this document other than the certifications required to establish: (1) your status as a qualified intermediary, a nonqualified intermediary, a specific type of U.S. branch, a withholding foreign partnership, a withholding foreign trust, a nonwithholding foreign partnership, a nonwithholding foreign simple trust, or a nonwithholding foreign grantor trust; (2) your chapter 4 status; and/or (3) prior to January 1, 2020, your status as a qualified securities lender.</SubstituteFormStatement>
        <WithholdingStatementAccounts />
    </W_8IMY_OCT_2021>`;
  console.log("Generated W-8IMY XML:", xml);
  return xml;
};

// <Line32IGACountry>${getValue("IMY-32_IGA_country")}</Line32IGACountry>
// <Line32Model1IGA>${getBooleanValue("IMY-32_model1_iga")}</Line32Model1IGA>
// <Line32Model2IGA>${getBooleanValue("IMY-32_model2_iga")}</Line32Model2IGA>
// <Line30Model1IGA>${getBooleanValue("IMY-32_model1_iga")}</Line30Model1IGA>
// <Line30Model2IGA>${getBooleanValue("IMY-32_model2_iga")}</Line30Model2IGA>
// <Line32TreatedAs>${getValue("IMY-32_treated_as") || getValue("IMY-32_Treated_as")}</Line32TreatedAs>
// <Line32TrusteeName>${getValue("IMY-32_Trustee_name")}</Line32TrusteeName>
// <Line32TrusteeUS>${getBooleanValue("IMY-32_trustee_us") }</Line32TrusteeUS>
// <Line32TrusteeForeign>${getBooleanValue("IMY-32_trustee_foreign")}</Line32TrusteeForeign>
